import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class CustomsService {

  /**
   * List of European Union countries
   * @private
   */
  private europeanUnion = [
    'BE', // Belgium
    'BG', // Bulgaria
    'CZ', // Czech Republic
    'DK', // Denmark
    'DE', // Germany
    'EE', // Estonia
    'IE', // Ireland
    'ES', // Spain
    'FR', // France
    'GR', // Greece
    'HR', // Croatia
    'IT', // Italy
    'CY', // Cyprus
    'LV', // Latvia
    'LT', // Lithuania
    'LU', // Luxembourg
    'HU', // Hungary
    'MT', // Malta
    'NL', // Netherlands
    'AT', // Austria
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SI', // Slovenia
    'SK', // Slovakia
    'FI', // Finland
    'SE', // Sweden
  ];

  /**
   * Source for isDutiable$ observable
   * @private
   */
  private isDutiableSource = new BehaviorSubject<boolean>(false);

  /**
   * Observable for isDutiableSource
   */
  isDutiable$ = this.isDutiableSource.asObservable();

  /**
   * Source for declaredValue$ observable
   * @private
   */
  private declaredValueSource = new BehaviorSubject<number>(null);

  /**
   * Observable for declaredValueSource
   */
  declaredValue$ = this.declaredValueSource.asObservable();

  /**
   * Check if shipment is dutiable
   * @param fromCountry
   * @param toCountry
   */
  setIsDutiable(fromCountry: string, toCountry: string): void {
    const fromCountryCode = fromCountry.toUpperCase();
    const toCountryCode = toCountry.toUpperCase();
    const isDutiable = (!this.isWithinEuropeanUnion(fromCountryCode) || !this.isWithinEuropeanUnion(toCountryCode))
      && fromCountryCode !== toCountryCode;

    this.isDutiableSource.next(isDutiable);
  }

  /**
   * Get isDutiable value
   */
  getIsDutiable() {
    return this.isDutiableSource;
  }

  /**
   * Set declared value
   * @param value
   */
  setDeclaredValue(value: number): void {
    this.declaredValueSource.next(value);
  }

  /**
   * Check if country is in European Union
   * @param country
   * @private
   */
  private isWithinEuropeanUnion(country: string): boolean {
    return this.europeanUnion.indexOf(country) !== -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/customs.service.ts